(ns minorodata.components.connections.extract-logs
  (:require
   [minorodata.app.handlers :refer [dispatch dispatch-sync]]
   [minorodata.components.log.table :refer [logs-row logs-spinner]]
   [minorodata.logs.model :refer [->logs-view]]
   [re-posh.core :as re-posh]
   [react :as react]
   [ui.table :refer [table tbody thead tr th]]))


(defn- message-mismatched?
  [message-id extract-id source-id]
  (let [message (:log-message/message @(re-posh/subscribe [:log-message/pull [:log-message/id message-id]]))]
    (or (when-let [msg-extract-id (:extract-id message)]
          (not= extract-id msg-extract-id))
        (when-let [msg-source-id (:source-id message)]
          (and (some? source-id) (not= source-id msg-source-id))))))

(defn extract-logs [{:keys [extract source]}]
  (let [extract-id   (:extract/extract-id extract)
        extract-name (:extract/name extract)
        source-id    (:source/source-id source)
        source-type  (:source/source-type source)
        term         @(re-posh/subscribe [:logs-view/prop :logs-view/term])
        logs         @(re-posh/subscribe [:logs-pager/prop :logs-pager/messages])
        loading?     @(re-posh/subscribe [:mold-http/loading? :logs.api/fetch])
        [ready-extract-id set-ready-extract-id] (react/useState nil)
        was-loading? (react/useRef false)
        fetched-term (react/useRef nil)]

    (react/useEffect
     (fn []
       (set-ready-extract-id nil)
       (set! (.-current fetched-term) extract-name)
       (dispatch [:logs-view/add
                  (->logs-view {:page   0
                                :source source-type
                                :term   extract-name})])
       (dispatch [:logs.api/fetch])
       (fn []
         (dispatch-sync [:logs-view/delete])))
     #js [extract-id extract-name source-type])

    (react/useEffect
     (fn []
       (when (and (some? term) (not= term (.-current fetched-term)))
         (set! (.-current fetched-term) term)
         (dispatch [:logs.api/fetch]))
       js/undefined)
     #js [term])

    (react/useEffect
     (fn []
       (when (and (.-current was-loading?) (not loading?))
         (set-ready-extract-id extract-id))
       (set! (.-current was-loading?) loading?)
       js/undefined)
     #js [loading?])

    (let [ready?       (= ready-extract-id extract-id)
          visible-logs (when ready?
                         (remove #(message-mismatched? % extract-id source-id) logs))]
      [:div {:class "relative flex h-full min-h-0 flex-col px-0"}
       [logs-spinner]

       (cond
         (seq visible-logs)
         [:div {:class "min-h-0 flex-1 overflow-auto"}
          [table {:data-cy "extract-logs-table" :class "table-fixed" :sticky-header true}
           [thead
            [tr
             [th {:style {:width "180px" :height "52px"}
                  :class "sticky top-0 z-20 border-r"}
              [:span "Date"]]
             [th {:style {:width "96px"}
                  :class "sticky top-0 z-20 border-r"}
              "Type"]
             [th {:class "sticky top-0 z-20 border-r"}
              "Message"]
             [th {:style {:width "80px"}
                  :class "sticky top-0 z-20"}
              "Task"]]]
           [tbody {}
            (for [message-id visible-logs]
              ^{:key message-id}
              [logs-row {:message-id      message-id
                         :skip-columns    ["source-name" "name"]
                         :interactive     false
                         :extract-context {:source-type source-type
                                           :extract-name extract-name}}])]]]

         (not ready?)
         nil

         :else
         [:p {:class "p-4 text-kleene-text-secondary"}
          "No logs found"])])))
